module.exports = __webpack_public_path__ + "img/policia_municipal_up_selected.12a5e48a.svg";